import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import rootSlice from './sclices/root-slice';
import couponsSlice from './sclices/coupons-slice';
import billingAddressSlice from './sclices/billing-address-slice';
import newCreditCardSlice from './sclices/new-credit-card-slice';
import savedCreditCardSlice from './sclices/saved-credit-card-slice';
import shippingAddressSlice from './sclices/shipping-address-slice';

const reducer = combineReducers({
    root: rootSlice.reducer,
    coupons: couponsSlice.reducer,
    billingAddress: billingAddressSlice.reducer,
    shippingAddress: shippingAddressSlice.reducer,
    newCreditCard: newCreditCardSlice.reducer,
    savedCreditCard: savedCreditCardSlice.reducer,
});

const store = configureStore({
    reducer,

    /**
     * this should be defined to prevent the following error:
     * '"A non-serializable value was detected in the state" when using redux toolkit - but NOT with normal redux'
     * https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
     */
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})

export const rootActions = rootSlice.actions;
export const couponActions = couponsSlice.actions;
export const billingAddressActions = billingAddressSlice.actions;
export const shippingAddressActions = shippingAddressSlice.actions;
export const newCreditCardActions = newCreditCardSlice.actions;
export const savedCreditCardActions = savedCreditCardSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;